import { useEffect, useRef, useState } from 'react'
import './items-landing.styles.scss';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ItemsList from './items-list.component';
import ItemsForm from './items-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { properCase } from '@/utils/properCase';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import ItemsUploadPage from './items-upload-page.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';

const ItemsLandingPage = ({
  gameElements,
  gameData,
  playerList,
  gameStats,
  role
}) => {

  const membership = useEffectiveMembership();
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [itemsFromDb, setItemsFromDb] = useState(null);
  const itemsRef = useRef();
  const location = useLocation();
  const itemsListenerRef = useRef();
  const navigate = useNavigate();

  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/manager');

  useEffect(() => {
    changeDocumentTitle(`Items | Manage ${gameData?.gameName}`, gameData?.icon);
  }, [gameData?.gameName])

  useEffect(() => {
    if (!gameData || !membership) return;
    checkMembership();
    function checkMembership() {
      const element = 'items'
      const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
      // console.log(res);

      if (res.disabled) {
        if (!membershipRestrictions) return;
        let message = ''
        const planRest = membershipRestrictions[membership.membership];
        if (res.disabledReason.includes(element)) {
          message = `While using the ${planRest.title}, ` + 
          `you are not able to access ${properCase(element)}.`;
        }
        setShowUpgradeModal(message)
      }
    }
  }, [membership, gameData]);

  useEffect(() => {
    if (!gameId) return;
    getGameElementsToManage();
    function getGameElementsToManage() {
      if (isPreview) {
        if (!completeGameElementData) return;
        const previewData = Object.values(completeGameElementData)
        .filter(el => el.type === 'item');
        itemsRef.current = {};
        previewData.forEach(item => {
          itemsRef.current[item.id] = item;
        });
        setItemsFromDb(itemsRef.current);
        return;
      }
      console.log('getting items from Db')
      getCollectionFromDb({
        "collection": `games/${gameId}/gameElements`,
        "query1": {
          "key": "type",
          "condition": "==",
          "value": "item"
        },
        "query2": {
          "key": "opt_itemType",
          "condition": "!=",
          "value": "prizepack"
        },
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        itemsRef.current = {
          ...itemsRef.current,
          ...{ [data.id]: data }
        }
        setItemsFromDb(itemsRef.current);
      }
      function handleListener(unsub) {
        itemsListenerRef.current = unsub;
      }
    }

    return () => {
      if (itemsListenerRef.current) {
        itemsListenerRef.current();
        itemsListenerRef.current = null;
      }
    }

  }, [gameId, isPreview, completeGameElementData])






  return (
    <div className='items-landing'>
      <Routes>
        <Route path='' element={
          <div className='g-card items-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer
                src='/images/icons/items.png'
                alt='items icon'
                className='head-icon'
              />
              Create and Edit Items
            </div>
            <hr />
            <div className='items-landing-content'>
              <ItemsList
                gameData={gameData}
                gameElements={gameElements}
                itemsFromDb={itemsFromDb}
                role={role} />
            </div>
          </div>
        }></Route>
        <Route path='upload' element={
          <ItemsUploadPage
            gameData={gameData}
            gameElements={gameElements}
            role={role}
          />
        }></Route>
        <Route path='create' element={
          <ItemsForm
            gameData={gameData}
            gameElements={gameElements}
            itemsFromDb={itemsFromDb}
            playerList={playerList}
            gameStats={gameStats}
            role={role} />
        }></Route>
        <Route path='edit/:itemPath' element={
          <ItemsForm
            gameData={gameData}
            gameElements={gameElements}
            itemsFromDb={itemsFromDb}
            playerList={playerList}
            gameStats={gameStats}
            role={role} />
        }></Route>
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default ItemsLandingPage